const PhotoSwipe = window.PhotoSwipe;
const PhotoSwipeLightbox = window.PhotoSwipeLightbox;

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  constructor () {
    super();
    this.currentThumbnailIndex = 0; // Track the starting index of the visible thumbnails
  }

  connectedCallback () {
    super.connectedCallback();

    if (!this.els?.link?.exists) return;

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 500,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 2,
      maxZoomLevel: 4,
      scaleMode: 'zoom',

      gallery: this.localName,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,

      closeOnVerticalDrag: false,
      tapAction: 'zoom',

      pswpModule: () => PhotoSwipe
    });

    this.setupPhotoSwipeListeners();
    this.photoSwipeInstance.init();
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addPreviousButton();
      this.addNextButton();
      this.addCloseButton();
      this.registerImageThumbnailsCarousel();
    });

    this.photoSwipeInstance.on('open', () => {
      this.pswp = this.photoSwipeInstance.pswp;
    });
  }

  addPreviousButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-prev',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-previous',
      ariaLabel: 'Previous',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.prev();
      },
    });
  }

  addNextButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-next',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-next',
      ariaLabel: 'Next',
      order: 3,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.next();
      },
    });
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close();
      },
    });
  }

  registerImageThumbnailsCarousel () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'thumbnailCarousel',
      className: 'pswp__thumbnail-carousel',
      appendTo: 'wrapper',
      onInit: (el, pswp) => {
        const thumbnails = this.createThumbnails(el, pswp);

        // Create Previous and Next buttons for the thumbnail carousel
        this.createThumbnailCarouselButtons(el, thumbnails);

        // Update thumbnail visibility initially after creating buttons
        this.updateThumbnailVisibility(thumbnails);
      }
    });
  }

  createThumbnails (el, pswp) {
    const thumbnails = [];
    for (let i = 0; i < pswp.getNumItems(); i++) {
      const bullet = document.createElement('div');
      bullet.className = 'pswp__bullet';

      const imgElement = document.createElement('img');
      imgElement.src = this.getThumbnailSrc(i);
      imgElement.className = 'pswp__bullet-img';
      bullet.appendChild(imgElement);

      bullet.onclick = () => {
        pswp.goTo(i);
      };

      el.appendChild(bullet);
      thumbnails.push(bullet);
    }

    pswp.on('change', () => {
      thumbnails.forEach((thumbnail, index) => {
      const isActive = index === pswp.currIndex;
      thumbnail.classList.toggle('pswp__bullet--active', isActive);
      if (isActive) {
        if (index > 3) {
          document.querySelector('.pswp__thumbnails-arrow--next').click();
        } else {
          document.querySelector('.pswp__thumbnails-arrow--prev').click();
        }
      }
      });
    });

    return thumbnails;
  }

  createThumbnailCarouselButtons (el, thumbnails) {
    const prevButton = document.createElement('button');
    prevButton.className = 'pswp__thumbnails-arrow--prev';
    prevButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" fill="none"><path stroke="currentColor" d="m5.624 9.465-4.569-4.43L5.485.466"></path></svg>`;
    prevButton.onclick = () => {
      this.currentThumbnailIndex = Math.max(0, this.currentThumbnailIndex - 1);
      this.updateThumbnailVisibility(thumbnails);
    };

    const nextButton = document.createElement('button');
    nextButton.className = 'pswp__thumbnails-arrow--next';
    nextButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" fill="none"><path stroke="currentColor" d="m.986 9.77 4.568-4.43L1.124.77"></path></svg>`;
    nextButton.onclick = () => {
      this.currentThumbnailIndex = Math.min(
        thumbnails.length - 4,
        this.currentThumbnailIndex + 1
      );
      this.updateThumbnailVisibility(thumbnails);
    };

    el.prepend(prevButton);
    el.appendChild(nextButton);

    // Save button references for enabling/disabling
    this.prevButton = prevButton;
    this.nextButton = nextButton;
  }

  updateThumbnailVisibility (thumbnails) {
    const maxVisibleThumbnails = 4;

    // Update the display of each thumbnail based on the current index
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.style.display = index >= this.currentThumbnailIndex &&
        index < this.currentThumbnailIndex + maxVisibleThumbnails ? 'inline-block' : 'none';
    });

    // Check if prevButton and nextButton exist before trying to set the disabled property
    if (this.prevButton) {
      this.prevButton.disabled = this.currentThumbnailIndex === 0;
    }
    if (this.nextButton) {
      this.nextButton.disabled = this.currentThumbnailIndex >= thumbnails.length - maxVisibleThumbnails;
    }
  }

  getThumbnailSrc (index) {
    const linkElement = this.els.link.elements[index];
    return linkElement.querySelector('img').src;
  }

  get arrowSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><path d="m3.854 1.555 3.182 3.182a.5.5 0 0 1 0 .707L3.854 8.626a.5.5 0 1 1-.708-.707l2.536-2.536v-.586L3.146 2.262a.5.5 0 1 1 .708-.707Z"/></svg>`;
  }

  get closeSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" fill-rule="evenodd" d="M15.789 16.498 1.646 2.355l.708-.707 14.142 14.143-.707.707Z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M16.496 2.354 2.354 16.496l-.708-.707L15.79 1.647l.707.707Z" clip-rule="evenodd"/></svg>`;
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe);
}